
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/solar",
      function () {
        return require("private-next-pages/shop/solar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/solar"])
      });
    }
  